module.exports = __webpack_public_path__ + "img/2.6_Indigenous-Advisory-Group_1_Wilson.79c2da20e285f6340e122b0d0a280bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_Indigenous-Advisory-Group_1_Wilson.png
// module id = 787
// module chunks = 0